(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jb-bulk-order"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('jb-bulk-order')) {
  class JBBulkOrder extends HTMLElement {
    static matches(product, condition) {
      const source = { TAG: product.tags, TITLE: [product.title], VENDOR: [product.vendor], TYPE: [product.type] }[condition.select];
      if (!source) return false;
      const needle = String(condition.value ?? '').toLocaleLowerCase();
      const equal = source.some(value => String(value).toLocaleLowerCase() === needle);
      const contains = source.some(value => String(value).toLocaleLowerCase().includes(needle));
      return { EQUALS: equal, NOT_EQUALS: !equal, CONTAINS: contains, NOT_CONTAINS: !contains }[condition.where] ?? false;
    }

    static optionSet(product, sets, country) {
      return sets.filter(set => {
        const config = set.config;
        if (Number(config.status) !== 0) return false;
        if (config.countries?.enable) {
          const included = config.countries.countries.includes(country);
          if (config.countries.type === 'include' ? !included : included) return false;
        }
        const rules = config.products?.rule;
        if (!rules) return false;
        if (rules.all?.enable) return true;
        if (rules.manual?.enable && rules.manual.ids.map(String).includes(String(product.id))) return true;
        const auto = rules.automate;
        if (!auto?.enable || !auto.conditions?.length) return false;
        const matches = auto.conditions.map(condition => this.matches(product, condition));
        return auto.operator === 'or' ? matches.some(Boolean) : matches.every(Boolean);
      }).sort((a, b) => Number(a.id) - Number(b.id)).at(-1);
    }

    static flatten(elements) {
      return (elements || []).flatMap(field => field.type === 'group' ? this.flatten(field.elements) : [field]);
    }

    static selection(product, row) {
      return product.variants.find(variant => variant.options.every((value, index) => value === row.options[index]));
    }

    static missingLines(items, cart) {
      const pending = [];
      for (const expected of items) {
        const found = cart.items.filter(item => item.properties?._jb_bulk_batch === expected.properties._jb_bulk_batch && item.properties?._jb_bulk_row === expected.properties._jb_bulk_row);
        if (!found.length) { pending.push(expected); continue; }
        const same = found.length === 1 && String(found[0].variant_id) === String(expected.id) && Number(found[0].quantity) === expected.quantity;
        if (!same || Object.entries(expected.properties).some(([key, value]) => String(found[0].properties?.[key] ?? '') !== String(value))) throw new Error('bulk_conflict');
      }
      return pending;
    }

    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.strings = Object.fromEntries(Object.entries(JSON.parse(this.querySelector('[data-bulk-strings]').textContent)).map(([key, value]) => [key, this.plain(value)]));
      this.sets = JSON.parse(this.querySelector('[data-bulk-rules]').textContent);
      this.products = new Map();
      this.rows = [];
      this.view = 'edit';
      this.storageKey = 'jbBulkOrder:1:' + this.dataset.collection;
      this.saved = this.readSaved();
      this.batch = this.saved?.batch || this.uid();
      this.pending = this.saved?.pending || null;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.addEventListener('click', event => this.handleClick(event), options);
      this.addEventListener('input', event => this.handleInput(event), options);
      this.addEventListener('change', event => this.handleChange(event), options);
      this.loadProducts();
    }

    disconnectedCallback() { this.controller?.abort(); }
    uid() { return crypto.randomUUID(); }
    t(key, values = {}) {
      const translated = Number(values.count) === 1 && this.strings[key + '_one'] ? this.strings[key + '_one'] : this.strings[key];
      return Object.entries(values).reduce((text, [name, value]) => text.replaceAll('{' + name + '}', String(value)), translated || key);
    }
    optionName(name) { return ({ size: this.t('size'), color: this.t('color'), colour: this.t('color') })[name.toLowerCase()] || name; }
    money(amount) { return new Intl.NumberFormat(this.dataset.locale, { style: 'currency', currency: this.dataset.currency }).format(amount / 100); }
    plain(value) { const el = document.createElement('template'); el.innerHTML = String(value || ''); return el.content.textContent.trim(); }

    element(tag, className, text) {
      const el = document.createElement(tag);
      if (className) el.className = className;
      if (text !== undefined) el.textContent = text;
      return el;
    }

    button(action, text, className = 'jb-bulk__small-button') {
      const button = this.element('button', className, text);
      button.type = 'button';
      button.dataset.action = action;
      return button;
    }

    async request(url, data) {
      const response = await fetch(url, {
        method: data ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store',
        headers: data ? { Accept: 'application/json', 'Content-Type': 'application/json' } : {},
        ...(data ? { body: JSON.stringify(data) } : {}), signal: AbortSignal.timeout(30000)
      });
      let body;
      try { body = await response.json(); } catch (error) {
        console.warn('Team order response could not be parsed', { url: response.url, status: response.status, type: response.headers.get('content-type'), reason: error.message });
        throw new Error(this.t('connection_error'));
      }
      if (!response.ok) throw new Error(body.description || body.message || this.t('connection_error'));
      return body;
    }

    async loadProducts() {
      this.clearError();
      this.loaded = false;
      this.products.clear();
      const status = this.querySelector('[data-catalog-status]');
      status.textContent = this.t('loading');
      this.querySelector('[data-retry]').hidden = true;
      try {
        let page = 1;
        let pages = 1;
        do {
          const url = new URL(this.dataset.collectionUrl, location.origin);
          url.searchParams.set('view', 'jb-bulk-data');
          url.searchParams.set('page', String(page));
          const data = await this.request(url);
          if (String(data.collection) !== this.dataset.collection || !Array.isArray(data.products)) {
            console.warn('Team order collection response mismatch', { collectionType: typeof data.collection, keys: Object.keys(data) });
            throw new Error(this.t('connection_error'));
          }
          if (data.allowed !== true) throw new Error(this.t('not_available'));
          for (const product of data.products) {
            product.id = String(product.id);
            const set = JBBulkOrder.optionSet(product, this.sets, this.dataset.country);
            product.optionSet = set ? String(set.id) : '';
            product.fields = JBBulkOrder.flatten(set?.config.elements).filter(field => field.type !== 'paragraph');
            product.unsupported = Boolean(product.incomplete || product.requiresSellingPlan || (set?.config.customers && !set.config.customers.rule?.all?.enable));
            for (const field of product.fields) {
              if (!['text', 'number', 'select', 'textarea'].includes(field.type) || field.conditionalField || field.addon_product?.variant_id || (field.option_values || []).some(value => value.variant_id || Number(value.price) > 0)) product.unsupported = true;
            }
            this.products.set(product.id, product);
          }
          pages = Number(data.pages);
          if (!Number.isInteger(pages) || pages < 1 || pages > 500) throw new Error(this.t('connection_error'));
          status.textContent = this.t('loaded_count', { count: this.products.size });
          page++;
        } while (page <= pages);
        this.loaded = true;
        this.restore();
        this.renderCatalog();
        this.renderRows();
        this.update();
        if (this.pending) this.showPending();
      } catch (error) {
        this.showError(error.message, false);
        status.textContent = this.t('load_failed');
        this.querySelector('[data-retry]').hidden = false;
      }
    }

    readSaved() {
      try {
        const data = JSON.parse(localStorage.getItem(this.storageKey));
        if (data?.version === 1 && Date.now() - data.time < 30 * 86400000 && Array.isArray(data.rows)) return data;
      } catch (_) {}
      return null;
    }

    restore() {
      if (!this.saved) return;
      let removed = 0;
      this.rows = this.saved.rows.slice(0, 200).flatMap(saved => {
        const product = this.products.get(String(saved.product));
        if (!product) { removed++; return []; }
        const fields = Object.fromEntries(product.fields.map(field => [field.id, String(saved.fields?.[field.id] || '').slice(0, 1000)]));
        return [{ id: String(saved.id || this.uid()), product: product.id, options: product.options.map((_, i) => String(saved.options?.[i] || '')), quantity: String(saved.quantity || '1'), fields, person: String(saved.person || '').slice(0, 100) }];
      });
      if (this.rows.length) this.querySelector('[data-save-status]').textContent = this.t('restored');
      if (removed) this.showError(this.t('removed_products', { count: removed }), false);
      this.saved = null;
    }

    save() {
      try {
        localStorage.setItem(this.storageKey, JSON.stringify({ version: 1, time: Date.now(), batch: this.batch, rows: this.rows, pending: this.pending }));
        this.querySelector('[data-save-status]').textContent = this.t('saved');
      } catch (_) { this.querySelector('[data-save-status]').textContent = this.t('not_saved'); }
    }

    renderCatalog() {
      const query = this.querySelector('[data-search]').value.trim().toLocaleLowerCase();
      const grid = this.querySelector('[data-catalog]');
      grid.replaceChildren();
      const products = [...this.products.values()].filter(product => (product.title + ' ' + product.type).toLocaleLowerCase().includes(query));
      for (const product of products) {
        const card = this.element('article', 'jb-bulk__product');
        const select = this.button('choose-product', '', 'jb-bulk__product-select');
        select.dataset.product = product.id;
        select.disabled = this.busy || Boolean(this.pending) || !product.available || product.unsupported;
        select.setAttribute('aria-label', this.t('choose_product', { product: product.title }));
        if (product.image) {
          const image = this.element('img');
          image.src = product.image;
          image.alt = '';
          image.loading = 'lazy';
          image.width = 360;
          image.height = 360;
          select.append(image);
        }
        select.append(this.element('span', 'jb-bulk__product-title', product.title));
        const price = this.money(product.price);
        select.append(this.element('span', 'jb-bulk__product-price', product.priceVaries ? this.t('from_price', { price }) : price));
        select.append(this.element('span', 'jb-bulk__product-action', product.available ? this.t('choose') : this.t('sold_out')));
        card.append(select);
        if (product.unsupported) {
          const link = this.element('a', 'jb-bulk__detail-link', this.t('special_options'));
          link.href = product.url;
          link.target = '_blank';
          link.rel = 'noopener';
          card.append(link);
        }
        grid.append(card);
      }
      this.querySelector('[data-no-results]').hidden = products.length > 0;
    }

    defaultRow(product, copy) {
      return {
        id: this.uid(), product: product.id,
        options: copy ? [...copy.options] : product.options.map((_, index) => {
          const values = [...new Set(product.variants.map(variant => variant.options[index]))];
          return values.length === 1 ? values[0] : '';
        }),
        quantity: copy ? copy.quantity : '1', fields: copy ? { ...copy.fields } : {}, person: copy ? copy.person : ''
      };
    }

    addRows(productId, count = 1, copy) {
      const product = this.products.get(String(productId));
      if (!product || !product.available || product.unsupported || this.busy || this.pending) return;
      if (this.rows.length + count > 200) { this.showError(this.t('row_limit')); return; }
      const added = Array.from({ length: count }, () => this.defaultRow(product, copy));
      this.rows.push(...added);
      this.renderRows();
      this.update();
      this.save();
      const row = this.querySelector('[data-row="' + added[0].id + '"]');
      row?.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      row?.querySelector('select, input')?.focus({ preventScroll: true });
      this.querySelector('[data-announcement]').textContent = this.t('added_rows', { count, product: product.title });
    }

    fieldWrap(label, input, required = false) {
      const wrapper = this.element('div', 'jb-bulk__field');
      const text = this.element('label', '', label + (required ? ' *' : ''));
      text.htmlFor = input.id;
      wrapper.append(text, input);
      return wrapper;
    }

    makeSelect(id, placeholder, values, current) {
      const select = this.element('select');
      select.id = id;
      select.append(new Option(placeholder, ''));
      for (const value of values) select.append(new Option(value, value));
      select.value = current || '';
      return select;
    }

    renderRows() {
      const container = this.querySelector('[data-order-groups]');
      container.replaceChildren();
      for (const productId of [...new Set(this.rows.map(row => row.product))]) {
        const product = this.products.get(productId);
        const group = this.element('section', 'jb-bulk__group');
        group.dataset.productGroup = productId;
        const header = this.element('div', 'jb-bulk__group-header');
        if (product.image) {
          const image = this.element('img'); image.src = product.image; image.alt = ''; image.width = 72; image.height = 72; header.append(image);
        }
        const heading = this.element('div');
        heading.append(this.element('h3', '', product.title));
        const details = this.element('a', 'jb-bulk__detail-link', this.t('product_details'));
        details.href = product.url; details.target = '_blank'; details.rel = 'noopener';
        details.setAttribute('aria-label', this.t('product_details_for', { product: product.title }));
        heading.append(details);
        header.append(heading);
        group.append(header);
        const rows = this.element('div', 'jb-bulk__rows');
        this.rows.filter(row => row.product === productId).forEach(row => rows.append(this.renderRow(product, row)));
        group.append(rows);
        const actions = this.element('div', 'jb-bulk__group-actions');
        for (const [count, key] of [[1, 'add_row'], [5, 'add_five']]) {
          const add = this.button('add-rows', this.t(key)); add.dataset.product = productId; add.dataset.count = count; actions.append(add);
        }
        group.append(actions);
        container.append(group);
      }
      this.querySelector('[data-empty-list]').hidden = this.rows.length > 0;
      this.querySelector('[data-order-intro]').hidden = this.rows.length === 0;
      if (this.pending) container.querySelectorAll('input,select,button').forEach(control => { control.disabled = true; });
    }

    renderRow(product, row) {
      const el = this.element('article', 'jb-bulk__row');
      el.dataset.row = row.id;
      const number = this.rows.indexOf(row) + 1;
      const header = this.element('div', 'jb-bulk__row-header');
      header.append(this.element('h4', '', this.t('position', { number })));
      const rowActions = this.element('div', 'jb-bulk__row-actions');
      const duplicate = this.button('duplicate-row', this.t('duplicate'));
      duplicate.setAttribute('aria-label', this.t('duplicate_position', { number }));
      const remove = this.button('remove-row', this.t('remove'), 'jb-bulk__remove');
      remove.setAttribute('aria-label', this.t('remove_position', { number }));
      rowActions.append(duplicate, remove);
      header.append(rowActions);
      el.append(header);
      const controls = this.element('div', 'jb-bulk__row-fields');
      product.options.forEach((name, index) => {
        if (product.onlyDefault) return;
        const values = [...new Set(product.variants.map(variant => variant.options[index]))];
        const select = this.makeSelect('bulk-' + row.id + '-option-' + index, this.t('select_option'), values, row.options[index]);
        select.dataset.variantOption = String(index);
        select.required = true;
        controls.append(this.fieldWrap(this.optionName(name), select, true));
      });
      const quantity = this.element('input');
      quantity.id = 'bulk-' + row.id + '-quantity'; quantity.type = 'number'; quantity.inputMode = 'numeric'; quantity.min = '1'; quantity.max = '9999'; quantity.step = '1'; quantity.value = row.quantity; quantity.required = true; quantity.dataset.quantity = '';
      controls.append(this.fieldWrap(this.t('quantity'), quantity, true));
      for (const field of product.fields) {
        const id = 'bulk-' + row.id + '-' + field.id;
        const label = this.plain(field.label_on_cart || field.label);
        let input;
        if (field.type === 'select') input = this.makeSelect(id, this.plain(field.placeholder) || this.t('select_option'), field.option_values.map(value => value.value), row.fields[field.id]);
        else {
          input = this.element(field.type === 'textarea' ? 'textarea' : 'input');
          input.id = id;
          if (field.type !== 'textarea') input.type = field.type === 'number' ? 'number' : 'text';
          input.value = row.fields[field.id] || '';
          input.autocomplete = 'off';
          if (field.type === 'number') {
            input.inputMode = 'numeric'; input.step = '1';
            if (field.min !== '' && field.min != null) input.min = String(field.min);
            if (field.max !== '' && field.max != null) input.max = String(field.max);
          } else input.maxLength = Number(field.max) > 0 ? Number(field.max) : 1000;
          if (field.placeholder) input.placeholder = this.plain(field.placeholder);
        }
        input.required = Boolean(field.required);
        input.dataset.personalField = field.id;
        controls.append(this.fieldWrap(label, input, input.required));
      }
      const person = this.element('input'); person.id = 'bulk-' + row.id + '-person'; person.type = 'text'; person.maxLength = 100; person.value = row.person; person.dataset.person = ''; person.autocomplete = 'off';
      const personField = this.fieldWrap(this.t('person'), person);
      const hint = this.element('small', '', this.t('person_help')); hint.id = person.id + '-hint'; person.setAttribute('aria-describedby', hint.id); personField.append(hint);
      controls.append(personField);
      el.append(controls);
      const footer = this.element('div', 'jb-bulk__row-footer');
      footer.append(this.element('span', 'jb-bulk__row-price'));
      const error = this.element('span', 'jb-bulk__row-error'); error.id = 'bulk-' + row.id + '-error'; error.hidden = true; error.setAttribute('role', 'status'); footer.append(error);
      el.append(footer);
      this.updateRow(el, product, row);
      return el;
    }

    updateRow(el, product, row) {
      const variant = JBBulkOrder.selection(product, row);
      for (const select of el.querySelectorAll('[data-variant-option]')) {
        const index = Number(select.dataset.variantOption);
        for (const option of select.options) {
          if (!option.value) continue;
          option.disabled = !product.variants.some(candidate => candidate.available && candidate.options[index] === option.value && candidate.options.every((value, other) => other === index || !row.options[other] || row.options[other] === value));
        }
      }
      const quantity = el.querySelector('[data-quantity]');
      quantity.min = String(variant?.rule?.min || 1); quantity.max = String(variant?.rule?.max || 9999); quantity.step = String(variant?.rule?.increment || 1);
      el.querySelector('.jb-bulk__row-price').textContent = variant ? (variant.available ? this.t('row_price', { price: this.money(variant.price), total: this.money(variant.price * (Number(row.quantity) || 0)) }) : this.t('sold_out')) : this.t('choose_variant');
    }

    handleInput(event) {
      if (event.target.matches('[data-search]')) { this.renderCatalog(); return; }
      const el = event.target;
      const rowEl = el.closest('[data-row]');
      if (!rowEl || this.busy || this.pending) return;
      const row = this.rows.find(item => item.id === rowEl.dataset.row);
      if (el.hasAttribute('data-quantity')) row.quantity = el.value;
      else if (el.hasAttribute('data-personal-field')) row.fields[el.dataset.personalField] = el.value;
      else if (el.hasAttribute('data-person')) row.person = el.value;
      else return;
      el.removeAttribute('aria-invalid');
      rowEl.querySelector('.jb-bulk__row-error').hidden = true;
      this.updateRow(rowEl, this.products.get(row.product), row);
      this.update();
      this.save();
    }

    handleChange(event) {
      const el = event.target;
      if (el.hasAttribute('data-personal-field')) { this.handleInput(event); return; }
      if (!el.hasAttribute('data-variant-option') || this.busy || this.pending) return;
      const rowEl = el.closest('[data-row]');
      const row = this.rows.find(item => item.id === rowEl.dataset.row);
      row.options[Number(el.dataset.variantOption)] = el.value;
      el.removeAttribute('aria-invalid');
      this.updateRow(rowEl, this.products.get(row.product), row);
      this.update();
      this.save();
    }

    handleClick(event) {
      const button = event.target.closest('button[data-action]');
      if (!button || !this.contains(button) || this.busy) return;
      const action = button.dataset.action;
      if (action === 'retry') { this.loadProducts(); return; }
      if (action === 'submit') { this.submit(); return; }
      if (action === 'reset-transfer') { this.resetTransfer(); return; }
      if (this.pending) return;
      if (action === 'choose-product') this.addRows(button.dataset.product);
      else if (action === 'add-rows') this.addRows(button.dataset.product, Number(button.dataset.count));
      else if (action === 'duplicate-row') {
        const row = this.rows.find(item => item.id === button.closest('[data-row]').dataset.row);
        this.addRows(row.product, 1, row);
      } else if (action === 'remove-row') {
        const index = this.rows.findIndex(item => item.id === button.closest('[data-row]').dataset.row);
        this.rows.splice(index, 1); this.renderRows(); this.update(); this.save();
      } else if (action === 'review') this.review();
      else if (action === 'edit') this.edit();
    }

    update() {
      let total = 0;
      let count = 0;
      let incomplete = 0;
      for (const row of this.rows) {
        const variant = JBBulkOrder.selection(this.products.get(row.product), row);
        const quantity = Number(row.quantity);
        if (variant && variant.available && Number.isInteger(quantity) && quantity > 0) { total += variant.price * quantity; count += quantity; }
        else incomplete++;
      }
      this.querySelectorAll('[data-total]').forEach(el => { el.textContent = this.money(total); });
      this.querySelectorAll('[data-item-count]').forEach(el => { el.textContent = this.t('item_count', { count }); });
      this.querySelector('[data-position-count]').textContent = this.t('position_count', { count: this.rows.length });
      this.querySelector('[data-incomplete]').textContent = incomplete ? this.t('incomplete_count', { count: incomplete }) : '';
      this.querySelectorAll('[data-action="review"]').forEach(button => { button.disabled = !this.rows.length || !this.loaded || this.busy || Boolean(this.pending); });
      this.querySelector('[data-edit]').hidden = this.view === 'review';
      this.querySelector('[data-review]').hidden = this.view !== 'review';
      this.querySelector('[data-summary-review]').hidden = this.view === 'review';
      this.querySelector('[data-mobile-bar]').hidden = this.view === 'review' || !this.rows.length || Boolean(this.pending);
    }

    validate() {
      this.clearError();
      let first = null;
      for (const row of this.rows) {
        const el = this.querySelector('[data-row="' + row.id + '"]');
        const product = this.products.get(row.product);
        const variant = JBBulkOrder.selection(product, row);
        const error = el.querySelector('.jb-bulk__row-error');
        let message = '';
        if (product.unsupported || !variant || !variant.available) message = this.t('choose_available');
        for (const input of el.querySelectorAll('input,select,textarea')) {
          const valid = input.checkValidity();
          if (!valid) { input.setAttribute('aria-invalid', 'true'); first ||= input; message ||= this.t('check_fields'); }
          else input.removeAttribute('aria-invalid');
        }
        if (message) { error.textContent = message; error.hidden = false; first ||= el.querySelector('select,input'); }
        else error.hidden = true;
      }
      if (first) { this.showError(this.t('fix_rows'), false); first.focus(); return false; }
      return this.rows.length > 0;
    }

    review() {
      if (!this.validate()) return;
      const list = this.querySelector('[data-review-lines]');
      list.replaceChildren();
      this.rows.forEach((row, index) => {
        const product = this.products.get(row.product);
        const variant = JBBulkOrder.selection(product, row);
        const li = this.element('li', 'jb-bulk__review-line');
        const info = this.element('div');
        info.append(this.element('h3', '', this.t('review_title', { number: index + 1, product: product.title })));
        if (!product.onlyDefault) info.append(this.element('p', '', product.options.map((name, i) => this.optionName(name) + ': ' + row.options[i]).join(' · ')));
        const properties = product.fields.filter(field => row.fields[field.id]).map(field => this.plain(field.label_on_cart || field.label) + ': ' + row.fields[field.id]);
        if (row.person) properties.push(this.t('person') + ': ' + row.person);
        if (properties.length) info.append(this.element('p', '', properties.join(' · ')));
        li.append(info, this.element('strong', '', this.t('review_price', { count: row.quantity, price: this.money(variant.price * Number(row.quantity)) })));
        list.append(li);
      });
      this.view = 'review';
      this.querySelector('[data-confirm]').checked = false;
      this.update();
      this.querySelector('[data-review-title]').focus();
    }

    edit() { this.view = 'edit'; this.update(); this.querySelector('[data-order-title]').focus(); }

    payload() {
      return this.rows.map(row => {
        const product = this.products.get(row.product);
        const variant = JBBulkOrder.selection(product, row);
        const properties = { Sammelbestellung: this.dataset.team, _jb_bulk_batch: this.batch, _jb_bulk_row: row.id };
        for (const field of product.fields) {
          const value = (row.fields[field.id] || '').trim();
          if (value) properties[this.plain(field.label_on_cart || field.label)] = value;
        }
        if (row.person.trim()) properties['Zuordnung im Team'] = row.person.trim();
        return { id: String(variant.id), quantity: Number(row.quantity), properties };
      });
    }

    showPending() {
      this.querySelector('[data-pending]').hidden = false;
      this.querySelector('[data-edit]').hidden = true;
      this.querySelector('[data-review]').hidden = true;
      this.querySelector('[data-mobile-bar]').hidden = true;
      this.querySelector('[data-summary-review]').hidden = true;
    }

    async submit() {
      if (this.busy) return;
      if (!this.pending) {
        if (this.view !== 'review') return;
        const confirmation = this.querySelector('[data-confirm]');
        if (!confirmation.checked) { this.showError(this.t('confirm_required'), false); confirmation.focus(); return; }
        this.pending = { items: this.payload(), created: Date.now() };
        this.save();
      }
      this.showPending();
      if (navigator.locks) {
        await navigator.locks.request('jb-bulk-cart', { ifAvailable: true }, async lock => {
          if (!lock) { this.showError(this.t('other_tab')); return; }
          await this.transfer();
        });
      } else await this.transfer();
    }

    async transfer() {
      this.busy = true;
      this.clearError();
      this.showPending();
      this.querySelectorAll('button').forEach(button => { button.disabled = true; });
      const status = this.querySelector('[data-transfer-status]');
      status.textContent = this.t('transferring');
      const root = this.dataset.root.replace(/\/?$/, '/');
      try {
        let cart = await this.request(root + 'cart.js');
        if (cart.currency !== this.dataset.currency) throw new Error(this.t('currency_changed'));
        let remaining = JBBulkOrder.missingLines(this.pending.items, cart);
        while (remaining.length) {
          const chunk = remaining.slice(0, 20);
          let addError = null;
          try { await this.request(root + 'cart/add.js', { items: chunk }); } catch (error) { addError = error; }
          cart = await this.request(root + 'cart.js');
          const after = JBBulkOrder.missingLines(this.pending.items, cart);
          status.textContent = this.t('transfer_progress', { current: this.pending.items.length - after.length, total: this.pending.items.length });
          if (addError && after.length) throw addError;
          if (after.length >= remaining.length) throw new Error(this.t('transfer_incomplete'));
          remaining = after;
        }
        this.rows = [];
        this.pending = null;
        this.batch = this.uid();
        try { localStorage.removeItem(this.storageKey); } catch (_) {}
        location.assign(this.dataset.cartUrl);
      } catch (error) {
        this.save();
        status.textContent = this.t('transfer_paused');
        this.querySelector('[data-pending-retry]').disabled = false;
        this.querySelector('[data-pending-reset]').disabled = false;
        this.showError(error.message === 'bulk_conflict' ? this.t('cart_conflict') : error.message, false);
      } finally { this.busy = false; }
    }

    async resetTransfer() {
      if (this.busy || !this.pending) return;
      const reset = async () => {
        this.busy = true;
        this.clearError();
        this.querySelectorAll('button').forEach(button => { button.disabled = true; });
        const status = this.querySelector('[data-transfer-status]');
        status.textContent = this.t('resetting');
        const root = this.dataset.root.replace(/\/?$/, '/');
        try {
          let cart = await this.request(root + 'cart.js');
          JBBulkOrder.missingLines(this.pending.items, cart);
          const expectedRows = new Set(this.pending.items.map(item => item.properties._jb_bulk_row));
          const batch = this.pending.items[0]?.properties._jb_bulk_batch;
          const owned = item => item.properties?._jb_bulk_batch === batch && expectedRows.has(item.properties?._jb_bulk_row);
          const updates = Object.fromEntries(cart.items.filter(owned).map(item => [item.key, 0]));
          if (Object.keys(updates).length) {
            let updateError = null;
            try { await this.request(root + 'cart/update.js', { updates }); } catch (error) { updateError = error; }
            cart = await this.request(root + 'cart.js');
            if (cart.items.some(owned)) throw updateError || new Error(this.t('reset_incomplete'));
          }
          this.pending = null;
          this.batch = this.uid();
          this.view = 'edit';
          this.busy = false;
          this.querySelectorAll('button').forEach(button => { button.disabled = false; });
          this.querySelector('[data-pending]').hidden = true;
          this.renderCatalog(); this.renderRows(); this.update(); this.save();
          this.querySelector('[data-order-title]').focus();
        } catch (error) {
          status.textContent = this.t('transfer_paused');
          this.querySelector('[data-pending-retry]').disabled = false;
          this.querySelector('[data-pending-reset]').disabled = false;
          this.showError(error.message === 'bulk_conflict' ? this.t('cart_conflict') : error.message, false);
        } finally { this.busy = false; }
      };
      if (navigator.locks) await navigator.locks.request('jb-bulk-cart', { ifAvailable: true }, async lock => {
        if (!lock) { this.showError(this.t('other_tab')); return; }
        await reset();
      });
      else await reset();
    }

    clearError() { this.querySelector('[data-error]').hidden = true; }
    showError(message, focus = true) {
      const error = this.querySelector('[data-error]'); error.textContent = message; error.hidden = false;
      if (focus) error.focus();
    }
  }
  customElements.define('jb-bulk-order', JBBulkOrder);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jb-catalog"]) return;
  try {
    
  (() => {
    function initCatalog(root) {
      root.querySelectorAll('[data-catalog-browser]').forEach((browser) => {
        if (browser.dataset.ready) return;
        browser.dataset.ready = 'true';
        const search = browser.querySelector('[data-catalog-search]');
        const category = browser.querySelector('[data-catalog-category]');
        const cards = Array.from(browser.querySelectorAll('[data-catalog-card]'));
        const count = browser.querySelector('[data-catalog-count]');
        const empty = browser.querySelector('[data-catalog-empty]');
        const normalize = (value) => value.toLocaleLowerCase(document.documentElement.lang || 'de').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ß/g, 'ss');
        function update() {
          const terms = normalize(search.value.trim()).split(/\s+/).filter(Boolean);
          let visible = 0;
          cards.forEach((card) => {
            const matches = (!category || !category.value || card.dataset.category === category.value) && terms.every((term) => normalize(card.dataset.search).includes(term));
            card.hidden = !matches;
            if (matches) visible += 1;
          });
          count.textContent = count.dataset.countTemplate.replace('[count]', String(visible));
          empty.hidden = visible !== 0;
        }
        search.addEventListener('input', update);
        if (category) category.addEventListener('change', update);
        browser.querySelectorAll('[data-catalog-reset]').forEach((button) => button.addEventListener('click', () => {
          search.value = '';
          if (category) category.value = '';
          update();
          search.focus();
        }));
        browser.querySelector('[data-catalog-controls]').hidden = false;
        update();
      });
    }
    initCatalog(document);
    document.addEventListener('shopify:section:load', (event) => initCatalog(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jb-collection-booking"] && !Shopify.designMode) return;
  try {
    
class JBCollectionBooking extends HTMLElement {
  static count(value) {
    return Math.max(0, Math.min(99, Math.floor(Number(value) || 0)));
  }

  static lines(state, models) {
    const lines = [];
    for (const model of models) {
      const chosen = model.logo ? state.logo === model.logo : Boolean(state.selected[model.key]);
      if (!chosen || !model.available || !model.id) continue;
      const counts = state.selected[model.key] || {};
      lines.push({ key: model.key, id: model.id, name: model.name, quantity: 1 + this.count(counts.main), price: model.price, kind: 'main' });
      const extra = this.count(counts.extra);
      if (extra && model.extraId && model.extraAvailable) lines.push({ key: model.key, id: model.extraId, name: model.name, quantity: extra, price: model.extraPrice, kind: 'extra' });
    }
    return lines;
  }

  static total(lines) {
    return lines.reduce((sum, line) => sum + line.price * line.quantity, 0);
  }

  static revisionComplete(cart, pending) {
    const actual = cart.items.filter(item => item.properties?._jb_setup_revision === pending.revision);
    return actual.length === pending.items.length && pending.items.every(wanted => actual.some(item => String(item.variant_id) === String(wanted.id) && item.quantity === wanted.quantity));
  }

  static oldUpdates(cart, config, revision) {
    return Object.fromEntries(cart.items.filter(item => item.properties?._jb_setup_id === config && item.properties?._jb_setup_revision !== revision).map(item => [item.key, 0]));
  }

  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.strings = Object.fromEntries([...this.querySelectorAll('[data-string]')].map(el => [el.dataset.string, el.textContent]));
    this.money = new Intl.NumberFormat(this.dataset.locale || 'de', { style: 'currency', currency: this.dataset.currency || 'EUR' });
    this.models = [...this.querySelectorAll('[data-product],[data-logo-model]')].map(el => ({
      el, key: el.dataset.key, name: el.dataset.name, id: el.dataset.id, price: Number(el.dataset.price) || 0,
      available: el.dataset.available === 'true', extraId: el.dataset.extraId, extraPrice: Number(el.dataset.extraPrice) || 0,
      extraAvailable: el.dataset.extraAvailable === 'true', logo: el.dataset.logoModel, group: el.dataset.group
    }));
    const params = new URLSearchParams(location.search);
    this.teamHandle = params.get('team') || '';
    this.teamId = params.get('team_id') || '';
    this.teamStatus = 'loading';
    this.storageKey = 'jbCollectionBooking:1:' + this.dataset.section + ':' + this.teamId + ':' + this.teamHandle;
    this.state = { team: '', logo: '', selected: {}, config: this.uid(), step: 1, filter: 'all', pending: null };
    this.restore();
    this.state.team = '';
    if (new URLSearchParams(location.search).get('category') === 'jersey') {
      this.state.filter = 'jersey';
      this.querySelector('[data-jersey-entry]').hidden = false;
    }
    this.querySelector('[data-team]').value = this.state.team;
    const logoRadio = [...this.querySelectorAll('[data-logo]')].find(el => el.value === this.state.logo && !el.disabled);
    if (logoRadio) logoRadio.checked = true;
    this.models.filter(model => !model.logo).forEach(model => { model.el.querySelector('[data-pick]').checked = Boolean(this.state.selected[model.key]); });
    this.querySelector('[data-summary]').open = !matchMedia('(max-width: 989px)').matches;
    this.onInput = event => this.handleInput(event);
    this.onChange = event => this.handleChange(event);
    this.onClick = event => this.handleClick(event);
    this.addEventListener('input', this.onInput);
    this.addEventListener('change', this.onChange);
    this.addEventListener('click', this.onClick);
    this.querySelector('[data-team]').addEventListener('keydown', event => { if (event.key === 'Enter') { event.preventDefault(); this.go(2); } });
    this.renderOptions();
    this.filter();
    this.go(this.state.step, false);
    this.update();
    this.observer = new IntersectionObserver(entries => {
      this.inWorkspace = entries[0].isIntersecting;
      this.updateMobileBar();
    });
    this.observer.observe(this.querySelector('.jb-setup__workspace'));
    this.loadTeam();
  }

  async loadTeam() {
    if (this.loadingTeam) return;
    this.loadingTeam = true;
    this.teamStatus = 'loading';
    this.teamContext = null;
    const notice = this.querySelector('[data-team-status]');
    const retry = this.querySelector('[data-team-retry]');
    const controls = [...this.querySelectorAll('[data-next],[data-add],[data-goto]')];
    controls.forEach(button => { button.disabled = true; });
    notice.textContent = this.strings.team_loading;
    retry.hidden = true;
    try {
      if (!/^[a-z0-9][a-z0-9-]{0,199}$/.test(this.teamHandle) || !/^[1-9][0-9]{0,19}$/.test(this.teamId)) throw new Error('Invalid team');
      const root = this.dataset.root.replace(/\/?$/, '/');
      const teamUrl = root + 'collections/' + encodeURIComponent(this.teamHandle);
      const endpoint = new URL(teamUrl, location.origin);
      endpoint.searchParams.set('view', 'jb-team-booking');
      const preview = new URLSearchParams(location.search).get('preview_theme_id');
      if (preview && /^[0-9]+$/.test(preview)) endpoint.searchParams.set('preview_theme_id', preview);
      const response = await fetch(endpoint, { credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(15000) });
      if (!response.ok) throw new Error('Team unavailable');
      const team = await response.json();
      if (!team || team.id !== this.teamId || team.handle !== this.teamHandle || typeof team.title !== 'string' || !team.title.trim()) throw new Error('Team mismatch');
      this.teamContext = { id: team.id, handle: team.handle, title: team.title, url: teamUrl };
      this.teamStatus = 'ready';
      this.state.team = team.title;
      this.querySelector('[data-team]').value = team.title;
      const heading = this.strings.team_heading.replace('{team}', team.title);
      this.querySelector('[data-booking-heading]').textContent = heading;
      document.title = heading + ' – JERSEYBOYS';
      notice.textContent = this.strings.team_assigned.replace('{team}', team.title);
      const back = this.querySelector('[data-team-return]');
      back.href = teamUrl;
      back.textContent = this.strings.return_team;
      if (this.state.pending && !this.state.pending.items?.every(item => item.properties?._jb_team_id === 'gid://shopify/Collection/' + team.id)) this.state.pending = null;
      this.clearError();
      this.update();
      this.save();
      controls.forEach(button => { button.disabled = false; });
    } catch (_) {
      this.teamStatus = 'error';
      this.state.team = '';
      this.querySelector('[data-team]').value = '';
      notice.textContent = this.teamHandle && this.teamId ? this.strings.team_error : this.strings.team_missing;
      retry.hidden = !this.teamHandle || !this.teamId;
      this.update();
    } finally {
      this.loadingTeam = false;
    }
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.removeEventListener('input', this.onInput);
    this.removeEventListener('change', this.onChange);
    this.removeEventListener('click', this.onClick);
    this.initialized = false;
  }

  uid() { return crypto.randomUUID(); }
  format(cents) { return this.money.format(cents / 100); }
  save() { try { sessionStorage.setItem(this.storageKey, JSON.stringify(this.state)); } catch (_) {} }

  restore() {
    try {
      const saved = JSON.parse(sessionStorage.getItem(this.storageKey));
      if (!saved || typeof saved.team !== 'string' || !saved.selected || typeof saved.config !== 'string') return;
      this.state.team = saved.team.slice(0, 100);
      this.state.config = saved.config;
      this.state.step = Math.max(1, Math.min(4, Number(saved.step) || 1));
      this.state.filter = ['all','jersey','teamwear','merch'].includes(saved.filter) ? saved.filter : 'all';
      this.state.pending = saved.pending || null;
      const validRadio = [...this.querySelectorAll('[data-logo]')].find(el => el.value === saved.logo && !el.disabled);
      this.state.logo = validRadio?.value || '';
      let changed = this.state.logo !== saved.logo;
      for (const [key, value] of Object.entries(saved.selected)) {
        const model = this.models.find(item => item.key === key);
        if (!model?.available || String(value.id) !== model.id) { changed = true; continue; }
        const extraValid = model.extraAvailable && String(value.extraId) === model.extraId;
        if (value.extra && !extraValid) changed = true;
        this.state.selected[key] = { id: model.id, extraId: model.extraId, main: JBCollectionBooking.count(value.main), extra: extraValid ? JBCollectionBooking.count(value.extra) : 0 };
      }
      if (changed) { this.state.step = 1; this.querySelector('[data-restore-notice]').hidden = false; }
    } catch (_) {}
  }

  handleInput(event) {
    const el = event.target;
    if (el.matches('[data-team]')) {
      this.state.team = this.teamContext?.title || '';
      el.value = this.state.team;
      el.removeAttribute('aria-invalid');
      this.clearError();
    } else if (el.matches('[data-count]')) {
      const row = el.closest('[data-option-key]');
      const model = this.models.find(item => item.key === row.dataset.optionKey);
      this.ensureSelection(model);
      this.state.selected[model.key][el.dataset.count] = JBCollectionBooking.count(el.value);
    } else return;
    this.update();
    this.save();
  }

  handleChange(event) {
    const el = event.target;
    if (el.matches('[data-count]')) { el.value = JBCollectionBooking.count(el.value); return; }
    if (el.matches('[data-logo]')) {
      this.state.logo = el.value;
      this.models.filter(model => model.logo && model.logo !== el.value).forEach(model => delete this.state.selected[model.key]);
      const selected = this.models.find(model => model.logo === el.value);
      if (selected) this.ensureSelection(selected);
    } else if (el.matches('[data-pick]')) {
      const model = this.models.find(item => item.el === el.closest('[data-product]'));
      if (el.checked) this.ensureSelection(model); else delete this.state.selected[model.key];
    } else return;
    this.clearError();
    this.renderOptions();
    this.update();
    this.save();
  }

  handleClick(event) {
    const button = event.target.closest('button');
    if (!button || !this.contains(button) || this.busy) return;
    if (button.hasAttribute('data-gallery-select')) {
      const pick = button.closest('[data-product]')?.querySelector('[data-pick]');
      if (pick && !pick.disabled && !pick.checked) pick.click();
    }
    else if (button.hasAttribute('data-goto')) this.go(Number(button.dataset.goto));
    else if (button.hasAttribute('data-next')) this.go(this.state.step + 1);
    else if (button.hasAttribute('data-back')) this.go(this.state.step - 1);
    else if (button.hasAttribute('data-filter')) { this.state.filter = button.dataset.filter; this.filter(); this.save(); }
    else if (button.hasAttribute('data-add')) this.submit();
    else if (button.hasAttribute('data-team-retry')) this.loadTeam();
  }

  ensureSelection(model) {
    this.state.selected[model.key] ||= { id: model.id, extraId: model.extraId, main: 0, extra: 0 };
  }

  errorFor(target) {
    if (target > 1 && this.teamStatus !== 'ready') return { step: 1, key: this.teamStatus === 'loading' ? 'team_loading' : 'team_error', focus: '[data-team]' };
    if (target > 1 && !this.state.team.trim()) return { step: 1, key: 'error_team', focus: '[data-team]' };
    if (target > 1 && !this.state.logo) return { step: 1, key: 'error_logo', focus: '[data-logo]:not(:disabled)' };
    if (target > 2 && !JBCollectionBooking.lines(this.state, this.models).length) return { step: 2, key: 'error_products', focus: '[data-step="2"] h2' };
    return null;
  }

  go(target, focus = true) {
    target = Math.max(1, Math.min(4, target));
    const error = this.errorFor(target);
    this.state.step = error ? error.step : target;
    this.querySelectorAll('[data-step]').forEach(el => { el.hidden = Number(el.dataset.step) !== this.state.step; });
    this.querySelectorAll('.jb-setup__steps [data-goto]').forEach(el => { if (Number(el.dataset.goto) === this.state.step) el.setAttribute('aria-current', 'step'); else el.removeAttribute('aria-current'); });
    this.querySelector('[data-back]').hidden = this.state.step === 1;
    this.querySelector('[data-next]').hidden = this.state.step === 4;
    this.querySelector('[data-progress]').textContent = this.strings.progress.replace('{step}', this.state.step);
    this.clearError();
    if (error && focus) this.showError(this.strings[error.key]);
    if (focus) {
      const focusEl = this.querySelector(error ? error.focus : `[data-step="${this.state.step}"] h2`);
      if (error?.key === 'error_team') focusEl.setAttribute('aria-invalid', 'true');
      this.querySelector('.jb-setup__workspace').scrollIntoView({ block: 'start', behavior: 'instant' });
      focusEl?.focus({ preventScroll: true });
    }
    this.updateMobileBar();
    this.save();
    return !error;
  }

  filter() {
    this.models.filter(model => !model.logo).forEach(model => { model.el.hidden = this.state.filter !== 'all' && this.state.filter !== model.group; });
    this.querySelectorAll('[data-filter]').forEach(el => el.setAttribute('aria-pressed', String(el.dataset.filter === this.state.filter)));
  }

  renderOptions() {
    const container = this.querySelector('[data-options]');
    container.replaceChildren();
    const active = JBCollectionBooking.lines(this.state, this.models).filter(line => line.kind === 'main');
    for (const line of active) {
      const model = this.models.find(item => item.key === line.key);
      this.ensureSelection(model);
      const card = this.querySelector('[data-option-template]').content.firstElementChild.cloneNode(true);
      card.dataset.optionKey = model.key;
      card.querySelector('[data-option-title]').textContent = model.name;
      card.querySelector('[data-main-price]').textContent = this.format(model.price);
      card.querySelector('[data-extra-price]').textContent = this.format(model.extraPrice);
      card.querySelector('[data-extra-row]').hidden = !model.extraId || !model.extraAvailable;
      for (const type of ['main', 'extra']) {
        const input = card.querySelector(`[data-count="${type}"]`);
        input.id = `${this.dataset.section}-${model.key}-${type}`;
        input.value = this.state.selected[model.key][type];
        card.querySelector(`[data-${type}-label]`).htmlFor = input.id;
      }
      container.append(card);
    }
  }

  update() {
    const lines = JBCollectionBooking.lines(this.state, this.models);
    for (const list of this.querySelectorAll('[data-summary-lines],[data-review-lines]')) {
      list.replaceChildren();
      for (const line of lines) {
        const li = document.createElement('li');
        const label = document.createElement('span');
        const price = document.createElement('strong');
        label.textContent = `${line.quantity} × ${line.name}${' · ' + (line.kind === 'extra' ? this.strings.line_extra : this.strings.line_design)}`;
        price.textContent = this.format(line.price * line.quantity);
        li.append(label, price);
        list.append(li);
      }
    }
    this.querySelectorAll('[data-total]').forEach(el => { el.textContent = this.format(JBCollectionBooking.total(lines)); });
    this.querySelector('[data-empty]').hidden = lines.length > 0;
    this.querySelector('[data-summary-team]').textContent = this.state.team.trim();
    this.querySelector('[data-review-team]').textContent = this.state.team.trim();
    this.querySelector('[data-review-logo]').textContent = this.strings['logo_' + this.state.logo] || '';
    if (this.state.logo === 'check') this.querySelector('[data-review-logo]').textContent += '. ' + this.strings.logo_check_hint;
    this.models.filter(model => !model.logo).forEach(model => {
      const selected = Boolean(this.state.selected[model.key]);
      if (model.available) model.el.querySelector('[data-pick-label]').textContent = selected ? this.strings.selected : this.strings.select;
      model.el.querySelectorAll('[data-gallery-select]').forEach(button => {
        button.disabled = !model.available;
        button.setAttribute('aria-pressed', String(selected));
      });
    });
  }

  updateMobileBar() { this.querySelector('[data-mobile-bar]').hidden = !this.inWorkspace || this.state.step === 4; }
  clearError() { this.querySelector('[data-error]').hidden = true; }
  showError(message) { const error = this.querySelector('[data-error]'); error.textContent = message; error.hidden = false; }

  async request(path, data) {
    const root = this.dataset.root.replace(/\/?$/, '/');
    const response = await fetch(root + path, {
      method: data ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store',
      headers: { 'Accept': 'application/json', ...(data ? { 'Content-Type': 'application/json' } : {}) },
      ...(data ? { body: JSON.stringify(data) } : {}), signal: AbortSignal.timeout(20000)
    });
    const body = await response.json();
    if (!response.ok) throw new Error(body.description || body.message || this.strings.error_cart);
    return body;
  }

  async settle(pending, cart) {
    if (!JBCollectionBooking.revisionComplete(cart, pending)) {
      const updates = Object.fromEntries(cart.items.filter(item => item.properties?._jb_setup_revision === pending.revision).map(item => [item.key, 0]));
      if (Object.keys(updates).length) await this.request('cart/update.js', { updates });
      this.state.pending = null;
      this.save();
      return false;
    }
    const updates = JBCollectionBooking.oldUpdates(cart, this.state.config, pending.revision);
    if (Object.keys(updates).length) await this.request('cart/update.js', { updates });
    this.state.pending = null;
    this.save();
    location.assign(this.dataset.cartUrl);
    return true;
  }

  async submit() {
    if (this.busy || !this.go(4, false)) return;
    this.busy = true;
    const button = this.querySelector('[data-add]');
    button.disabled = true;
    button.textContent = this.strings.cart_busy;
    this.querySelector('[data-cart-check]').hidden = true;
    let navigated = false;
    try {
      const cart = await this.request('cart.js');
      if (this.state.pending) {
        navigated = await this.settle(this.state.pending, cart);
        if (!navigated) this.showError(this.strings.error_cart);
        return;
      }
      const revision = this.uid();
      const items = JBCollectionBooking.lines(this.state, this.models).map(line => ({ id: Number(line.id), quantity: line.quantity, properties: {
        Team: this.teamContext.title, Teamshop: new URL(this.teamContext.url, location.origin).href,
        _jb_team_id: 'gid://shopify/Collection/' + this.teamContext.id, _jb_team_handle: this.teamContext.handle, _jb_booking_type: 'new_collection',
        Bundle: 'Design Konfigurator', Namespace: 'design_konfigurator',
        Modell: line.name,
        Logo: this.strings['logo_' + this.state.logo],
        ...(line.kind === 'extra' ? { Typ: 'Zusatzoption' } : {}),
        _jb_setup_id: this.state.config, _jb_setup_revision: revision
      } }));
      this.state.pending = { revision, items };
      this.save();
      try { await this.request('cart/add.js', { items }); } catch (_) {}
      navigated = await this.settle(this.state.pending, await this.request('cart.js'));
      if (!navigated) this.showError(this.strings.error_cart);
    } catch (_) {
      this.showError(this.state.pending ? this.strings.error_reconcile : this.strings.error_cart);
      this.querySelector('[data-cart-check]').hidden = false;
    } finally {
      if (!navigated) {
        this.busy = false;
        button.disabled = false;
        button.textContent = this.strings.cart;
        if (!this.querySelector('[data-error]').hidden) this.querySelector('.jb-setup__workspace').scrollIntoView({ block: 'start', behavior: 'instant' });
      }
    }
  }
}
if (!customElements.get('jb-collection-booking')) customElements.define('jb-collection-booking', JBCollectionBooking);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jb-shop-setup"] && !Shopify.designMode) return;
  try {
    
class JBShopSetup extends HTMLElement {
  static count(value) {
    return Math.max(0, Math.min(99, Math.floor(Number(value) || 0)));
  }

  static lines(state, models) {
    const lines = [];
    for (const model of models) {
      const chosen = model.logo ? state.logo === model.logo : Boolean(state.selected[model.key]);
      if (!chosen || !model.available || !model.id) continue;
      const counts = state.selected[model.key] || {};
      lines.push({ key: model.key, id: model.id, name: model.name, quantity: 1 + this.count(counts.main), price: model.price, kind: 'main' });
      const extra = this.count(counts.extra);
      if (extra && model.extraId && model.extraAvailable) lines.push({ key: model.key, id: model.extraId, name: model.name, quantity: extra, price: model.extraPrice, kind: 'extra' });
    }
    return lines;
  }

  static total(lines) {
    return lines.reduce((sum, line) => sum + line.price * line.quantity, 0);
  }

  static revisionComplete(cart, pending) {
    const actual = cart.items.filter(item => item.properties?._jb_setup_revision === pending.revision);
    return actual.length === pending.items.length && pending.items.every(wanted => actual.some(item => String(item.variant_id) === String(wanted.id) && item.quantity === wanted.quantity));
  }

  static oldUpdates(cart, config, revision) {
    return Object.fromEntries(cart.items.filter(item => item.properties?._jb_setup_id === config && item.properties?._jb_setup_revision !== revision).map(item => [item.key, 0]));
  }

  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.strings = Object.fromEntries([...this.querySelectorAll('[data-string]')].map(el => [el.dataset.string, el.textContent]));
    this.money = new Intl.NumberFormat(this.dataset.locale || 'de', { style: 'currency', currency: this.dataset.currency || 'EUR' });
    this.models = [...this.querySelectorAll('[data-product],[data-logo-model]')].map(el => ({
      el, key: el.dataset.key, name: el.dataset.name, id: el.dataset.id, price: Number(el.dataset.price) || 0,
      available: el.dataset.available === 'true', extraId: el.dataset.extraId, extraPrice: Number(el.dataset.extraPrice) || 0,
      extraAvailable: el.dataset.extraAvailable === 'true', logo: el.dataset.logoModel, group: el.dataset.group
    }));
    this.storageKey = 'jbShopSetup:3:' + this.dataset.section;
    this.state = { team: '', logo: '', selected: {}, config: this.uid(), step: 1, filter: 'all', pending: null };
    this.restore();
    if (new URLSearchParams(location.search).get('category') === 'jersey') {
      this.state.filter = 'jersey';
      this.querySelector('[data-jersey-entry]').hidden = false;
    }
    this.querySelector('[data-team]').value = this.state.team;
    const logoRadio = [...this.querySelectorAll('[data-logo]')].find(el => el.value === this.state.logo && !el.disabled);
    if (logoRadio) logoRadio.checked = true;
    this.models.filter(model => !model.logo).forEach(model => { model.el.querySelector('[data-pick]').checked = Boolean(this.state.selected[model.key]); });
    this.querySelector('[data-summary]').open = !matchMedia('(max-width: 989px)').matches;
    this.onInput = event => this.handleInput(event);
    this.onChange = event => this.handleChange(event);
    this.onClick = event => this.handleClick(event);
    this.addEventListener('input', this.onInput);
    this.addEventListener('change', this.onChange);
    this.addEventListener('click', this.onClick);
    this.querySelector('[data-team]').addEventListener('keydown', event => { if (event.key === 'Enter') { event.preventDefault(); this.go(2); } });
    this.renderOptions();
    this.filter();
    this.go(this.state.step, false);
    this.update();
    this.observer = new IntersectionObserver(entries => {
      this.inWorkspace = entries[0].isIntersecting;
      this.updateMobileBar();
    });
    this.observer.observe(this.querySelector('.jb-setup__workspace'));
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.removeEventListener('input', this.onInput);
    this.removeEventListener('change', this.onChange);
    this.removeEventListener('click', this.onClick);
    this.initialized = false;
  }

  uid() { return crypto.randomUUID(); }
  format(cents) { return this.money.format(cents / 100); }
  save() { try { sessionStorage.setItem(this.storageKey, JSON.stringify(this.state)); } catch (_) {} }

  restore() {
    try {
      const saved = JSON.parse(sessionStorage.getItem(this.storageKey));
      if (!saved || typeof saved.team !== 'string' || !saved.selected || typeof saved.config !== 'string') return;
      this.state.team = saved.team.slice(0, 100);
      this.state.config = saved.config;
      this.state.step = Math.max(1, Math.min(4, Number(saved.step) || 1));
      this.state.filter = ['all','jersey','teamwear','merch'].includes(saved.filter) ? saved.filter : 'all';
      this.state.pending = saved.pending || null;
      const validRadio = [...this.querySelectorAll('[data-logo]')].find(el => el.value === saved.logo && !el.disabled);
      this.state.logo = validRadio?.value || '';
      let changed = this.state.logo !== saved.logo;
      for (const [key, value] of Object.entries(saved.selected)) {
        const model = this.models.find(item => item.key === key);
        if (!model?.available || String(value.id) !== model.id) { changed = true; continue; }
        const extraValid = model.extraAvailable && String(value.extraId) === model.extraId;
        if (value.extra && !extraValid) changed = true;
        this.state.selected[key] = { id: model.id, extraId: model.extraId, main: JBShopSetup.count(value.main), extra: extraValid ? JBShopSetup.count(value.extra) : 0 };
      }
      if (changed) { this.state.step = 1; this.querySelector('[data-restore-notice]').hidden = false; }
    } catch (_) {}
  }

  handleInput(event) {
    const el = event.target;
    if (el.matches('[data-team]')) {
      this.state.team = el.value;
      el.removeAttribute('aria-invalid');
      this.clearError();
    } else if (el.matches('[data-count]')) {
      const row = el.closest('[data-option-key]');
      const model = this.models.find(item => item.key === row.dataset.optionKey);
      this.ensureSelection(model);
      this.state.selected[model.key][el.dataset.count] = JBShopSetup.count(el.value);
    } else return;
    this.update();
    this.save();
  }

  handleChange(event) {
    const el = event.target;
    if (el.matches('[data-count]')) { el.value = JBShopSetup.count(el.value); return; }
    if (el.matches('[data-logo]')) {
      this.state.logo = el.value;
      this.models.filter(model => model.logo && model.logo !== el.value).forEach(model => delete this.state.selected[model.key]);
      const selected = this.models.find(model => model.logo === el.value);
      if (selected) this.ensureSelection(selected);
    } else if (el.matches('[data-pick]')) {
      const model = this.models.find(item => item.el === el.closest('[data-product]'));
      if (el.checked) this.ensureSelection(model); else delete this.state.selected[model.key];
    } else return;
    this.clearError();
    this.renderOptions();
    this.update();
    this.save();
  }

  handleClick(event) {
    const button = event.target.closest('button');
    if (!button || !this.contains(button) || this.busy) return;
    if (button.hasAttribute('data-gallery-select')) {
      const pick = button.closest('[data-product]')?.querySelector('[data-pick]');
      if (pick && !pick.disabled && !pick.checked) pick.click();
    }
    else if (button.hasAttribute('data-goto')) this.go(Number(button.dataset.goto));
    else if (button.hasAttribute('data-next')) this.go(this.state.step + 1);
    else if (button.hasAttribute('data-back')) this.go(this.state.step - 1);
    else if (button.hasAttribute('data-filter')) { this.state.filter = button.dataset.filter; this.filter(); this.save(); }
    else if (button.hasAttribute('data-add')) this.submit();
  }

  ensureSelection(model) {
    this.state.selected[model.key] ||= { id: model.id, extraId: model.extraId, main: 0, extra: 0 };
  }

  errorFor(target) {
    if (target > 1 && !this.state.team.trim()) return { step: 1, key: 'error_team', focus: '[data-team]' };
    if (target > 1 && !this.state.logo) return { step: 1, key: 'error_logo', focus: '[data-logo]:not(:disabled)' };
    if (target > 2 && !JBShopSetup.lines(this.state, this.models).length) return { step: 2, key: 'error_products', focus: '[data-step="2"] h2' };
    return null;
  }

  go(target, focus = true) {
    target = Math.max(1, Math.min(4, target));
    const error = this.errorFor(target);
    this.state.step = error ? error.step : target;
    this.querySelectorAll('[data-step]').forEach(el => { el.hidden = Number(el.dataset.step) !== this.state.step; });
    this.querySelectorAll('.jb-setup__steps [data-goto]').forEach(el => { if (Number(el.dataset.goto) === this.state.step) el.setAttribute('aria-current', 'step'); else el.removeAttribute('aria-current'); });
    this.querySelector('[data-back]').hidden = this.state.step === 1;
    this.querySelector('[data-next]').hidden = this.state.step === 4;
    this.querySelector('[data-progress]').textContent = this.strings.progress.replace('{step}', this.state.step);
    this.clearError();
    if (error && focus) this.showError(this.strings[error.key]);
    if (focus) {
      const focusEl = this.querySelector(error ? error.focus : `[data-step="${this.state.step}"] h2`);
      if (error?.key === 'error_team') focusEl.setAttribute('aria-invalid', 'true');
      this.querySelector('.jb-setup__workspace').scrollIntoView({ block: 'start', behavior: 'instant' });
      focusEl?.focus({ preventScroll: true });
    }
    this.updateMobileBar();
    this.save();
    return !error;
  }

  filter() {
    this.models.filter(model => !model.logo).forEach(model => { model.el.hidden = this.state.filter !== 'all' && this.state.filter !== model.group; });
    this.querySelectorAll('[data-filter]').forEach(el => el.setAttribute('aria-pressed', String(el.dataset.filter === this.state.filter)));
  }

  renderOptions() {
    const container = this.querySelector('[data-options]');
    container.replaceChildren();
    const active = JBShopSetup.lines(this.state, this.models).filter(line => line.kind === 'main');
    for (const line of active) {
      const model = this.models.find(item => item.key === line.key);
      this.ensureSelection(model);
      const card = this.querySelector('[data-option-template]').content.firstElementChild.cloneNode(true);
      card.dataset.optionKey = model.key;
      card.querySelector('[data-option-title]').textContent = model.name;
      card.querySelector('[data-main-price]').textContent = this.format(model.price);
      card.querySelector('[data-extra-price]').textContent = this.format(model.extraPrice);
      card.querySelector('[data-extra-row]').hidden = !model.extraId || !model.extraAvailable;
      for (const type of ['main', 'extra']) {
        const input = card.querySelector(`[data-count="${type}"]`);
        input.id = `${this.dataset.section}-${model.key}-${type}`;
        input.value = this.state.selected[model.key][type];
        card.querySelector(`[data-${type}-label]`).htmlFor = input.id;
      }
      container.append(card);
    }
  }

  update() {
    const lines = JBShopSetup.lines(this.state, this.models);
    for (const list of this.querySelectorAll('[data-summary-lines],[data-review-lines]')) {
      list.replaceChildren();
      for (const line of lines) {
        const li = document.createElement('li');
        const label = document.createElement('span');
        const price = document.createElement('strong');
        label.textContent = `${line.quantity} × ${line.name}${' · ' + (line.kind === 'extra' ? this.strings.line_extra : this.strings.line_design)}`;
        price.textContent = this.format(line.price * line.quantity);
        li.append(label, price);
        list.append(li);
      }
    }
    this.querySelectorAll('[data-total]').forEach(el => { el.textContent = this.format(JBShopSetup.total(lines)); });
    this.querySelector('[data-empty]').hidden = lines.length > 0;
    this.querySelector('[data-summary-team]').textContent = this.state.team.trim();
    this.querySelector('[data-review-team]').textContent = this.state.team.trim();
    this.querySelector('[data-review-logo]').textContent = this.strings['logo_' + this.state.logo] || '';
    if (this.state.logo === 'check') this.querySelector('[data-review-logo]').textContent += '. ' + this.strings.logo_check_hint;
    this.models.filter(model => !model.logo).forEach(model => {
      const selected = Boolean(this.state.selected[model.key]);
      if (model.available) model.el.querySelector('[data-pick-label]').textContent = selected ? this.strings.selected : this.strings.select;
      model.el.querySelectorAll('[data-gallery-select]').forEach(button => {
        button.disabled = !model.available;
        button.setAttribute('aria-pressed', String(selected));
      });
    });
  }

  updateMobileBar() { this.querySelector('[data-mobile-bar]').hidden = !this.inWorkspace || this.state.step === 4; }
  clearError() { this.querySelector('[data-error]').hidden = true; }
  showError(message) { const error = this.querySelector('[data-error]'); error.textContent = message; error.hidden = false; }

  async request(path, data) {
    const root = this.dataset.root.replace(/\/?$/, '/');
    const response = await fetch(root + path, {
      method: data ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store',
      headers: { 'Accept': 'application/json', ...(data ? { 'Content-Type': 'application/json' } : {}) },
      ...(data ? { body: JSON.stringify(data) } : {}), signal: AbortSignal.timeout(20000)
    });
    const body = await response.json();
    if (!response.ok) throw new Error(body.description || body.message || this.strings.error_cart);
    return body;
  }

  async settle(pending, cart) {
    if (!JBShopSetup.revisionComplete(cart, pending)) {
      const updates = Object.fromEntries(cart.items.filter(item => item.properties?._jb_setup_revision === pending.revision).map(item => [item.key, 0]));
      if (Object.keys(updates).length) await this.request('cart/update.js', { updates });
      this.state.pending = null;
      this.save();
      return false;
    }
    const updates = JBShopSetup.oldUpdates(cart, this.state.config, pending.revision);
    if (Object.keys(updates).length) await this.request('cart/update.js', { updates });
    this.state.pending = null;
    this.save();
    location.assign(this.dataset.cartUrl);
    return true;
  }

  async submit() {
    if (this.busy || !this.go(4, false)) return;
    this.busy = true;
    const button = this.querySelector('[data-add]');
    button.disabled = true;
    button.textContent = this.strings.cart_busy;
    this.querySelector('[data-cart-check]').hidden = true;
    let navigated = false;
    try {
      const cart = await this.request('cart.js');
      if (this.state.pending) {
        navigated = await this.settle(this.state.pending, cart);
        if (!navigated) this.showError(this.strings.error_cart);
        return;
      }
      const revision = this.uid();
      const items = JBShopSetup.lines(this.state, this.models).map(line => ({ id: Number(line.id), quantity: line.quantity, properties: {
        Team: this.state.team.trim(), Bundle: 'Design Konfigurator', Namespace: 'design_konfigurator',
        Modell: line.name,
        Logo: this.strings['logo_' + this.state.logo],
        ...(line.kind === 'extra' ? { Typ: 'Zusatzoption' } : {}),
        _jb_setup_id: this.state.config, _jb_setup_revision: revision
      } }));
      this.state.pending = { revision, items };
      this.save();
      try { await this.request('cart/add.js', { items }); } catch (_) {}
      navigated = await this.settle(this.state.pending, await this.request('cart.js'));
      if (!navigated) this.showError(this.strings.error_cart);
    } catch (_) {
      this.showError(this.state.pending ? this.strings.error_reconcile : this.strings.error_cart);
      this.querySelector('[data-cart-check]').hidden = false;
    } finally {
      if (!navigated) {
        this.busy = false;
        button.disabled = false;
        button.textContent = this.strings.cart;
        if (!this.querySelector('[data-error]').hidden) this.querySelector('.jb-setup__workspace').scrollIntoView({ block: 'start', behavior: 'instant' });
      }
    }
  }
}
if (!customElements.get('jb-shop-setup')) customElements.define('jb-shop-setup', JBShopSetup);


  } catch(e) { console.error(e); }
})();
})();
